import React from 'react';
import PropTypes from 'prop-types';
import cssClasses from './Modals.css';

const ModalsHeader = (props) => {
    return <div className={cssClasses.modal_header}>
        <h4 className={cssClasses.modal_title}>{props.title}</h4>
        <button type="button" onClick={props.closeModal} className={cssClasses.modal_close} aria-label="Close">
            <span aria-hidden="true">×</span>
        </button>
    </div>
}

ModalsHeader.propTypes = {
    title: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
};


export default ModalsHeader;


// WEBPACK FOOTER //
// ./src/components/Modals/ModalsHeader.js